import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF'
    },
    nameText: { fontWeight: 'bold' as const },
    accountText: { fontSize: '.8rem' }
});